/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Wie breit das Eingabefeld im Baustein steht (Betreiber 16.09.2026:
 * „Datenfeldgröße (Toggle) komplett bzw. mit Rand. Wenn mit Rand bitte
 * die Größe um 10% reduzieren so dass das Feld etwas kleiner wird."):
 * 
 *   KOMPLETT — das Feld nimmt die volle Breite des Bausteins ein.
 *   MIT_RAND — das Feld wird an JEDER Seite um `randBreite` Pixel
 *              gekuerzt. Wie viele, sagt die Zahl; ohne sie aendert
 *              sich nichts.
 * 
 * Die SCHRIFT bleibt davon unberuehrt — unter 16 px zoomt das Telefon
 * beim Antippen von selbst.
 * 
 * Ohne Angabe gilt KOMPLETT — so, wie es bisher aussah.
 * @export
 */
export const DatabaseEingabelisteFeldGroesse = {
    Komplett: 'KOMPLETT',
    MitRand: 'MIT_RAND'
} as const;
export type DatabaseEingabelisteFeldGroesse = typeof DatabaseEingabelisteFeldGroesse[keyof typeof DatabaseEingabelisteFeldGroesse];


export function DatabaseEingabelisteFeldGroesseFromJSON(json: any): DatabaseEingabelisteFeldGroesse {
    return DatabaseEingabelisteFeldGroesseFromJSONTyped(json, false);
}

export function DatabaseEingabelisteFeldGroesseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseEingabelisteFeldGroesse {
    return json as DatabaseEingabelisteFeldGroesse;
}

export function DatabaseEingabelisteFeldGroesseToJSON(value?: DatabaseEingabelisteFeldGroesse | null): any {
    return value as any;
}

